import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-draft",
  "use": "icon-draft-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-draft\"><defs><style type=\"text/css\"></style></defs><path d=\"M777 542V162H247v380h-55v320h640V542h-55zM307 222h410v320h-82.314l-12.725 70H402.039l-12.725-70H307V222z m465 580H252V602h87.236l12.725 70h320.078l12.725-70H772v200z\" p-id=\"2702\" fill=\"#999999\" /><path d=\"M392 302h240v60H392z m30 110h180v60H422z\" p-id=\"2703\" fill=\"#999999\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol